/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerSegmentsSimpleSearchQueryResponse, PntAppControllerSegmentsSimpleSearchPathParams, PntAppControllerSegmentsSimpleSearchQueryParams } from "../models/PntAppControllerSegmentsSimpleSearch";

export function getPntAppControllerSegmentsSimpleSearchUrl(slug: PntAppControllerSegmentsSimpleSearchPathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/simple-search` as const }
  return res
}

/**
 * @summary Search the segments's transciptions for the given terms in the given date range using the elastic's `simple_query_string` query.
 * {@link /pnt/v2/segments/:slug/simple-search}
 */
export async function pntAppControllerSegmentsSimpleSearch(slug: PntAppControllerSegmentsSimpleSearchPathParams["slug"], params: PntAppControllerSegmentsSimpleSearchQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntAppControllerSegmentsSimpleSearchQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntAppControllerSegmentsSimpleSearchUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}